import React from "react";

type IconProps = {
    color?: string;
    size?: number | string;
    className?: string;
};

const FacebookIcon: React.FC<IconProps> = ({
                                               color = "white",
                                               size = 24,
                                               className,
                                           }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width={size}
        height={size}
        fill={color}
        className={className}
    >
        <path d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554v386.892c0,34.524-28.03,62.554-62.554,62.554h-106.468v-192.915h66.6l12.672-82.621h-79.272v-53.617c0-22.603 11.073-44.636 46.58-44.636h36.042v-70.34s-32.71-5.582-63.982-5.582c-65.288,0-107.96,39.569-107.96,111.204v62.971h-72.573v82.621h72.573v192.915h-191.104c-34.524,0-62.554-28.03-62.554-62.554v-386.892C0,28.03,28.029,0,62.554,0h386.892Z" />
    </svg>
);

export default FacebookIcon;